import UOfALogo from "../assets/collaborators/ua-coph.png";
import WRPHTCLogo from "../assets/collaborators/WRPHTC.png";
import PCDHLogo from "../assets/collaborators/PCDH-logo.png";
import VisitMesaLogo from "../assets/collaborators/visit-mesa-logo.png";
import BCBSAZLogo from "../assets/collaborators/azbcbs_logo.png";
import PhxChildrensLogo from "../assets/collaborators/phx_shildrens_hospital_logo.webp";
import VitalystLogo from "../assets/collaborators/vitalyst_logo.png";

export interface SharedCollaborator {
  id: string;
  name: string;
  logo: string;
  link: string;
  description: string;
  showInHomepageCarousel: boolean;
}

export const sharedCollaborators: SharedCollaborator[] = [
  {
    id: "ua-mezcoph",
    name: "Mel & Enid Zuckerman College of Public Health",
    logo: UOfALogo,
    link: "https://publichealth.arizona.edu/",
    description:
      "The UA Zuckerman College of Public Health provides both undergraduate and graduate education in population-based health disciplines designed to prepare students for professional and academic public-health careers.",
    showInHomepageCarousel: true
  },
  {
    id: "bcbs-az",
    name: "BlueCross BlueShield Arizona",
    logo: BCBSAZLogo,
    link: "https://www.azblue.com/",
    description: "",
    showInHomepageCarousel: true
  },
  {
    id: "phoenix-childrens",
    name: "Phoenix Children's",
    logo: PhxChildrensLogo,
    link: "https://www.phoenixchildrens.org/",
    description: "",
    showInHomepageCarousel: true
  },
  {
    id: "wrphtc",
    name: "Western Region Public Health Training Center",
    logo: WRPHTCLogo,
    link: "https://wrphtc.arizona.edu/",
    description:
      "The Western Region Public Health Training Center is a Continuing Professional Education (CPE) Accredited Provider with the Commission on Dietetic Registration (CDR).",
    showInHomepageCarousel: true
  },
  {
    id: "pcdh",
    name: "Pima County Health Department",
    logo: PCDHLogo,
    link: "https://webcms.pima.gov/government/health_department/",
    description:
      "The Pima County Health Department is dedicated to help the residents of Pima County achieve and maintain an optimal level of wellness.",
    showInHomepageCarousel: true
  },
  {
    id: "visit-mesa",
    name: "Visit Mesa",
    logo: VisitMesaLogo,
    link: "https://www.visitmesa.com/",
    description:
      "Visit Mesa is the official destination marketing organization for Mesa, Arizona. They promote tourism and community engagement through inclusive travel initiatives, including Mesa's designation as the world's first Autism Certified City.",
    showInHomepageCarousel: true
  },
  {
    id: "vitalyst",
    name: "Vitalyst Health Foundation",
    logo: VitalystLogo,
    link: "https://vitalysthealth.org/",
    description: "",
    showInHomepageCarousel: true
  }
];
